import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Select, Text } from '@reveni-io/reveni-ui'

import { pageSizeOptions } from './constants'
import * as Styles from './styles'

const PageSizeSelector = ({ value = 25, onChange }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="bodyMRegular">{t('Resultados por página')}:</Text>
      <Select
        value={value}
        onChange={onChange}
        options={pageSizeOptions}
        backgroundColor={theme.colors.background.secondary}
      />
    </Styles.Container>
  )
}

export default PageSizeSelector
